module.exports = __webpack_public_path__ + "static/media/tick.15d05aec.svg";